const Resume_Api = [
    {
      id: 1,
      category: "wrkexp",
      year: "April 2023 - Aug 2024",
      company: "London American City College, UAE",
      title: "Digital Marketing Specialist cum Web Designers",
      desc: "The website lacc.ae, lacc.me, & other lacc websites have been redesigned to be more user-friendly on all platforms. Online advertising Google Ads & Facebook campaigns are managed & generated quality leads. Created engaging content, infographics, & reels for social media platforms for Facebook, Instagram, LinkedIn, YouTube & Twitter to promote the college's brand. Using keyword research, on-page, & off-page SEO strategies are optimized for the college's website to improve visibility & organic traffic on search engines.",
    },
    {
      id: 2,
      category: "wrkexp",
      year: "2 Years and 3 Months | Dec 2020 - March 2023 ",
      company: "Firstcry.Com, Pune",
      title: "SEO Associate",
      desc: "Developed an article blueprint for a Firstcry Parenting Website, offering expert guidance for parents. Created engaging and informative content across various parenting topics, including newborn essentials, baby development milestones, breastfeeding, sleep training, nutrition, and child safety. Conducted keyword research(SEMrush) and implemented strategic SEO techniques to optimize content for search engine visibility.",
    },
    {
      id: 3,
      category: "experience",
      year: "6 Months | June 2020 - Nov 2020",
      company: "Clariwell Global Services Institute, Pune",
      title: "Digital Marketing Intern",
      desc: "Worked with the SEO team on projects involving On-Page and Off-Page optimization for client websites. Worked with social media optimisation by posting posters on client websites. Extra skills learned: Email Marketing, Google Analytics, Keyword Research, Keyword Optimisation & Link Building.",
    },
    {
      id: 4,
      category: "experience",
      year: "8 Months | Oct 2019 - MAY 2020",
      company: "CodeOps Technologies LLP, Bangalore",
      title: "UI Designer",
      desc: "Successfully designed and implemented a user-friendly and responsive UI for the Konfhub platform. Collaborated closely with cross-functional teams to understand user requirements and translate them into visually appealing design solutions. Prototyping tools (Figma, Sketch), Usability testing tools, Responsive design frameworks.",
    },
  ]
  
  export default Resume_Api
  